import "vue-tsx-support/enable-check"
import {VNode} from 'vue'
import * as tsx from "vue-tsx-support";
import './cellRenderTsx.less'
import './addRemoveRender.less'
import _ from 'lodash'
import './RequiredHead.less'

type Fn = (params: any) => boolean

export interface CheckboxHeadStateI {
    showSelect?: boolean
    onCheck?(v: boolean, params:any)
    selected?: boolean
    indeterminate?: boolean
}

const CheckboxHead = tsx.componentFactory.create({
	data () {
		return {
			select: false
		}
	},
	methods: {
		input(v) {
            let headerComponentFrameworkOpt: CheckboxHeadStateI = (this.params.column.colDef.headerComponentFrameworkOpt as CheckboxHeadStateI) || {};
            headerComponentFrameworkOpt.onCheck && headerComponentFrameworkOpt.onCheck(v, this.params);
        },
	},
	created () {},
	render (h): VNode {
		let headerComponentFrameworkOpt: CheckboxHeadStateI = ((this.params.column.colDef.headerComponentFrameworkOpt) as CheckboxHeadStateI) || {}
        let {showSelect,indeterminate} = headerComponentFrameworkOpt
		return <div>
            <checkbox v-if={showSelect} v-model={headerComponentFrameworkOpt.selected} on-on-change={this.input.bind(this)} indeterminate={indeterminate}/>
			{this.params.displayName}
		</div>

	}
})
export default CheckboxHead
